module.exports = __webpack_public_path__ + "img/jk-2.8826504e.png";